Vue.component("MpPrice", {
    props: {
        label: {
            type: String,
            default: function () {
                return '';
            }
        },
        value: {
            type: Number,
        },
        variation: {
            type: Number,
        },
        decimals: {
            type: Number,
            default: function () {
                return -1;
            }
        },
        tendence: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        align: {
            type: String,
            default: function () {
                return '';
            }
        },
        inline: {
            type: Boolean,
            default: function () {
                return false;
            }
        }
    },
    data: function() {
        return {};
    },
    computed: {
        price: function() {
            if (typeof this.value === null) return;
            return (this.decimals !== -1) ? this.$options.filters.decimals(this.value, this.decimals) : this.value;
        },

        priceVar: function() {
            if (typeof this.variation === null) return;

            var valueSign = (!this.tendence && this.variation > 0) ? '+' : '';
            return (this.decimals !== -1) ? valueSign + this.$options.filters.decimals(this.variation, this.decimals) : valueSign + this.variation;
        },

        style: function() {
            return {
                'price--align-left': (this.align === 'left'),
                'price--align-right': (this.align === 'right'),
                'price--inline': this.inline,
            };
        },

        styleVar: function() {
            return {
                'price__var--positive': this.variation > 0,
                'price__var--negative': this.variation < 0,
            };
        },
    },

    methods: {},

    template: '\
    <div class="price" :class="style">\
        <span class="price__label" v-if="label">{{label}}</span>\
        <span class="price__value" v-if="price">{{price}}</span>\
        <span class="price__var" :class="styleVar" v-if="variation">\
            <span class="price__var-arrow icon icon--xxs" v-if="tendence">\
                <svg class="icon__inner" width="10" height="5" viewBox="0 0 16 8" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h16L8 8" fill="currentColor" fill-rule="evenodd"/></svg>\
            </span>\
            <span class="price__var-value">{{priceVar}}</span>\
        </span>\
    </div>',
});